import { StepsInfoInterface } from './Steps';
import { UserInfoType } from './User';

export type ContactType = {
  GSI1PK: string;
  GSI1SK: string;
  PK: string;
  SK: string;
  createdAt: number;
  description: null | string;
  file: null;
  id: string;
  imageUrl: string;
  listContact: Array<ContactMemberType>;
  name: string;
  owner: OwnerType;
  steps: Array<StepsInfoInterface>;
  totalContact: number;
  totalFeedback: number;
  totalUsefulScore: number;
  totalView: number;
  totalViewThisMonth: number;
  totalViewLastYear: number;
  updatedAt: number;
};

export interface Contact {
  firstname: string;
  lastname: string;
  sub: string;
  email: string;
  idHowTo?: string;
}

export type ContactMemberType = {
  email: string;
  firstname: string;
  lastname: string;
  sub: string;
};

export type OwnerType = {
  PK: string;
  SK: string;
  contactLimit: number;
  createdAt: number;
  email: string;
  firstname: string;
  instructionLimit: number;
  lastname: string;
  sub: string;
  subscriptionType: string;
  totalInstruction: number;
  updatedAt: number;
  username: string;
};

export type HowToInfoType = {
  name: string;
  id?: string;
  imageUrl?: string;
  steps?: Array<StepsInfoInterface>;
  canEdit: boolean;
  description?: string;
  owner?: UserInfoType;
  isDraft?: boolean;
  idDraft?: string;
  createdAt?: number;
  updatedAt: number;
  totalView?: number;
  totalViewThisMonth?: number;
  totalViewLastYear?: number;
  totalFeedback?: number;
  totalUsefulScore?: number;
  totalContact?: number;
  listContact?: Array<Contact>;
  contactLimit?: number;
  happinessPercentage?: number;
};

export enum SubscriptionTypeEnum {
  FREE = 'free',
  PRO = 'pro',
  TEAM = 'team',
  ENTERPRISE = 'enterprise',
}
